import * as styles from './border.module.scss';

import React from 'react';

const TextBorder = ({ text='Please add some text', color }) => (
  <span className={styles.text} style={{ borderBottomColor: color }}>{text}</span>
)

export default TextBorder;
